export default __webpack_public_path__ + "static/gift-note-preview-cc106db714016e8752dd1cd3ffedaaaf.png";